import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  outerContainer:{
    border: '2px solid #000',
    display: 'flex',
    flexDirection: 'row'
  },
  title:{
    flex: 1,
    padding:'5px',
    fontSize:"large",
    height:80
  },
  infoIcon:{
    color: "#676868",
    alignSelf:"flex-end",
    margin:'3px'
  },
  boldText :{
    fontWeight: 'bold',
    fontSize: '3rem',
    color: 'black',
    lineHeight: 1,
    marginRight: '16px !important'
  },
  innerContainer:{
    display: 'flex',
    flexDirection:'column'
  }
}));
